import React from "react";

const Footer = () => {
  return (
    <footer
      className="py-2"
      style={{ backgroundColor: "#fffcf5", color: "#000000" }} 
    >
      <div className="container text-center">
        {/* Logo */}
        <div className="mb-2">
          <img
            src="https://www.psritservices.com/images/logo.jpg"
            alt="PSR-IT Services Logo"
            style={{ height: "50px" }}
          />
        </div>

        {/* Links */}
        <div className="row justify-content-center">
          <div className="col-md-4 text-center">
            <h6
              className="text-uppercase fw-bold"
              style={{ color: "#000000", fontSize: "1rem" }}
            >
              Quick Links
            </h6>
            <a
              href="/Services"
              className="text-dark fw-semibold d-block"
              style={{ fontSize: "0.9rem" }}
            >
              Services
            </a>
            <a
              href="/careers"
              className="text-dark fw-semibold d-block"
              style={{ fontSize: "0.9rem" }}
            >
              Careers
            </a>
            <a
              href="/contact"
              className="text-dark fw-semibold d-block"
              style={{ fontSize: "0.9rem" }}
            >
              Contact Us
            </a>
          </div>
          <div className="col-md-4 text-center">
            <h6
              className="text-uppercase fw-bold"
              style={{ color: "#000000", fontSize: "1rem" }}
            >
              Company
            </h6>
            <a
              href="/Home"
              className="text-dark fw-semibold d-block"
              style={{ fontSize: "0.9rem" }}
            >
              Home
            </a>
            <a
              href="/AboutUs"
              className="text-dark fw-semibold d-block"
              style={{ fontSize: "0.9rem" }}
            >
              About Us
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container text-center mt-2">
        <p
          className="mb-0"
          style={{
            fontSize: "1.2rem",
            fontWeight: "700",
            letterSpacing: "0.5px",
          }}
        >
          &copy; 2011
          <span style={{ color: "#5a0000", fontSize: "1.3rem" }}>
            {" "}PSR-IT Services
          </span>{" "}
          -{" "}
          <span style={{ fontSize: "1.3rem", fontWeight: "700" }}>
            All Rights Reserved
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
